import PrivacyPolicyUpdates from './privacy-policy-updates'
import { connector } from './connector'

export default connector(PrivacyPolicyUpdates)
